import { createModel } from '@rematch/core';
import { Insurance } from '../../models/insurance';
import { storeData } from '../../utils';
import { getInsurancesAsync } from '../../apis/insurance';

export interface State {
    allIds: number[];
    byId: Dictionary<Insurance>;
    loading: Dictionary<boolean>;
}

export const insurances = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<MixType<Insurance>>,
            action?: string
        ): State => {
            const byId = {
                ...state.byId,
                ...storeData(data, 'id')
            };
            return {
                ...state,
                allIds: Object
                    .keys(byId)
                    .sort((a, b) => byId[a]!.insuranceType > byId[b]!.insuranceType ? 1 : -1)
                    .map(x => +x),
                byId: byId,
                ...action && {
                    loading: {
                        ...state.loading,
                        [action]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            action: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [action]: loading
            }
        })
    },
    effects: () => ({
        async getInsurancesAsync() {
            this.loading('getInsurancesAsync', true);
            try {
                const data = await getInsurancesAsync();
                this.update(data, 'getInsurancesAsync');
            } catch (e) {
                window.console.log(e);
                this.loading('getInsurancesAsync', false);
            }
        }
    })
});
